import { motion } from "framer-motion";

const products = [
  {
    name: "Wireless Earbuds",
    price: "$79",
    rating: 4,
    imgGradient: "linear-gradient(135deg, hsl(239 84% 67% / 0.2), hsl(280 60% 55% / 0.15))",
    x: "4%", y: "5%", w: "44%", h: "52%",
  },
  {
    name: "Smart Watch",
    price: "$199",
    rating: 5,
    imgGradient: "linear-gradient(135deg, hsl(150 60% 50% / 0.15), hsl(180 60% 45% / 0.2))",
    x: "52%", y: "5%", w: "44%", h: "52%",
  },
];

const transactions = [
  { item: "Earbuds Pro", amount: "+$79.00", delay: 0 },
  { item: "Smart Watch X", amount: "+$199.00", delay: 3 },
  { item: "USB-C Cable", amount: "+$12.99", delay: 6 },
];

export const ShoppingFlowBg = () => (
  <div className="absolute inset-0 overflow-hidden">
    {/* Product cards */}
    {products.map((p, i) => (
      <motion.div
        key={i}
        className="absolute rounded-xl border border-white/[0.1] flex flex-col overflow-hidden"
        style={{
          width: p.w, height: p.h, left: p.x, top: p.y,
          backgroundColor: "hsl(0 0% 100% / 0.04)",
        }}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 + i * 0.2, duration: 0.6 }}
      >
        {/* Product image area */}
        <div
          className="flex-1 m-[5px] mb-0 rounded-lg flex items-center justify-center relative overflow-hidden"
          style={{ background: p.imgGradient }}
        >
          {/* Abstract product shape */}
          <motion.div
            className="w-[50%] h-[50%] rounded-lg border border-white/[0.1]"
            style={{ backgroundColor: "hsl(0 0% 100% / 0.06)" }}
            animate={{ rotate: [0, 3, -3, 0] }}
            transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
          />
          {/* Shine effect */}
          <motion.div
            className="absolute inset-0"
            style={{
              background: "linear-gradient(105deg, transparent 40%, hsl(0 0% 100% / 0.06) 50%, transparent 60%)",
            }}
            animate={{ x: ["-100%", "200%"] }}
            transition={{ duration: 3, repeat: Infinity, repeatDelay: 4, ease: "easeInOut" }}
          />
        </div>

        {/* Product info */}
        <div className="px-[6px] py-[5px] flex flex-col gap-[2px]">
          <span className="text-[6px] text-white/40 truncate">{p.name}</span>
          <div className="flex items-center justify-between">
            <span className="text-[8px] font-mono font-bold text-emerald-400/70">{p.price}</span>
            <div className="flex gap-[1px]">
              {Array.from({ length: 5 }, (_, j) => (
                <div
                  key={j}
                  className="w-[3px] h-[3px] rounded-[0.5px]"
                  style={{
                    backgroundColor: j < p.rating
                      ? "hsl(45 90% 60% / 0.6)"
                      : "hsl(0 0% 100% / 0.1)",
                  }}
                />
              ))}
            </div>
          </div>
          <motion.div
            className="h-[11px] rounded-full flex items-center justify-center mt-[2px]"
            style={{ backgroundColor: "hsl(239 84% 67% / 0.35)" }}
            animate={{ scale: [1, 1.04, 1] }}
            transition={{ duration: 2.5, repeat: Infinity, delay: i * 1.2 + 1 }}
          >
            <span className="text-[5px] font-bold text-indigo-200/70">Add to Cart</span>
          </motion.div>
        </div>
      </motion.div>
    ))}

    {/* Live sales feed */}
    <div className="absolute bottom-[5%] left-[4%] right-[4%] flex flex-col gap-[4px]">
      {transactions.map((tx, i) => (
        <motion.div
          key={i}
          className="flex items-center gap-[6px] rounded-lg px-[6px] py-[4px] border border-white/[0.08]"
          style={{ backgroundColor: "hsl(0 0% 100% / 0.04)" }}
          initial={{ opacity: 0, x: -16 }}
          animate={{ opacity: [0, 1, 1, 0], x: [-16, 0, 0, 16] }}
          transition={{
            duration: 4,
            repeat: Infinity,
            delay: tx.delay,
            ease: "easeInOut",
            repeatDelay: 5,
          }}
        >
          <motion.div
            className="w-[4px] h-[4px] rounded-full bg-emerald-400/70 shrink-0"
            animate={{ scale: [1, 1.5, 1], opacity: [0.7, 1, 0.7] }}
            transition={{ duration: 1.2, repeat: Infinity }}
          />
          <span className="text-[5px] text-white/30 truncate flex-1">{tx.item}</span>
          <span className="text-[6px] font-mono font-bold text-emerald-400/60 shrink-0">{tx.amount}</span>
        </motion.div>
      ))}
    </div>

    {/* Cart badge */}
    <motion.div
      className="absolute top-[5%] right-[4%] flex items-center gap-1 rounded-full px-[6px] py-[3px] border border-white/[0.1]"
      style={{ backgroundColor: "hsl(239 84% 67% / 0.2)" }}
      animate={{ scale: [1, 1.1, 1] }}
      transition={{ duration: 0.4, repeat: Infinity, repeatDelay: 3 }}
    >
      <span className="text-[5px] text-white/30">Cart</span>
      <span className="text-[6px] font-bold text-indigo-300/80">3</span>
    </motion.div>
  </div>
);
